import { useContext } from 'react';
import { Button, Grid, Paper } from '@mui/material';
import useStyles from '../Modals.styles';
import { FormattedMessage } from 'react-intl';
import useSettingsModalStyles from './SettingsModal.styles';
import DeleteOrQuitFolderButton from './DeleteOrQuitFolderButton';
import { settingsContext } from './SettingsContext';
import DeleteDocumentButton from '../DeleteFiles/DeleteDocumentButton';
import {Close} from 'components/icons';

type SettingsModalPureProps = {
  handleHide: () => void;
};

const SettingsModalPure = ({
  handleHide,
}: SettingsModalPureProps): JSX.Element => {
  const classes = useStyles();
  const settingsModalClasses = useSettingsModalStyles();

  return (
    <div className={classes.container}>
      <Paper className={settingsModalClasses.modal}>
        <Button aria-label="Fermer" className={classes.closeButton} onClick={handleHide}>
          <Close fontSize='large' />
        </Button>

        <Grid container>
          <Grid className={classes.text} item xs={12}>
            <FormattedMessage id="share.folder.settings.title" />
          </Grid>

          <Grid className={settingsModalClasses.buttonContainer} item xs={12}>
            <DeleteDocumentButton />
          </Grid>

          <Grid className={settingsModalClasses.buttonContainer} item xs={12}>
            <DeleteOrQuitFolderButton />
          </Grid>
        </Grid>
      </Paper>
    </div>
  );
};

const SettingsModal = (): JSX.Element | null => {
  const { showSettingsModal, setShowSettingsModal } =
    useContext(settingsContext);

  if (!showSettingsModal) {
    return null;
  }

  return <SettingsModalPure handleHide={() => setShowSettingsModal(false)} />;
};

export default SettingsModal;
